module.exports = __webpack_public_path__ + "img/91.2.TN.5dcbd46f.png";